import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from 'src/app//auth/auth.service';
import { DateRange, MomentHelper } from 'src/app//models/date';
import { OrdersSearch } from 'src/app//models/orders';
import { appCodes, AvailableOptions, DeliveryMethods, DeliveryMethodValues, emptyFields, PaymentModeIcons, PaymentModes, Status, UsersType } from 'src/app//utilities/common-file';
import { CommonService } from 'src/app//utilities/common-service';
import { Messages } from 'src/app//utilities/message';
import { NzTableData } from 'src/app//utilities/nz-table.adapter';
import { OrdersService } from '../orders.service';
import { NzInputDirective } from 'ng-zorro-antd/input';
import EncryptStorage from 'encrypt-storage';
import { ProductOffersComponent } from 'src/app/products/product-offers/product-offers.component';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-new-orders',
  templateUrl: './new-orders.component.html',
})
export class NewOrdersComponent implements OnInit {
  public tableData: NzTableData<OrdersSearch, any> = new NzTableData<OrdersSearch, any>(new OrdersSearch(), 'name');
  public selectTableData: NzTableData<OrdersSearch, any> = new NzTableData<OrdersSearch, any>(new OrdersSearch(), 'name');
  public pendingTableData: NzTableData<OrdersSearch, any> = new NzTableData<OrdersSearch, any>(new OrdersSearch(), 'name');
  loading = false;
  loadingforCheckOut=false;
  isHoldData=false;
  selectedIndex=0;
  pendingCartLoading=false;
  merchantId: any;
  locationId: any;
  currencySymbol='';
   selectedProduct: any;
  notifyLogout: any;
  hashId:any;
  selectedLocation:any;
  selectedMerchantProduct: any;
  status = Status;
  emptyField = emptyFields;
  editId: string | null;
  @ViewChild(NzInputDirective, { static: false, read: ElementRef }) inputElement: ElementRef;
   loadingforProductList = false;
  loadingforPay=false;
  loginUserType = '';
  orderId:number;
  paymentModes=PaymentModes;
  paymentIcons=PaymentModeIcons;
  availableOptions=AvailableOptions;
  deliveryMethods = DeliveryMethods;
  orderNumber='';
  remainingAmount=0;
  userType = UsersType;
  deliMethods=DeliveryMethodValues;
  isActiveCart=false;
   locationsList = [];
  defaultQtyValue: number = 1;
   getRowData: any;
   totalAmount:any;
   totalSavings:any;
   totalProducts:any;
   totalFinalAmount:any;
  // All product List
  productList: any[] = [];
   allProductIsEdit = false;
 
  //Pending Cart List
  pendingCartList: any[] = [];

  // Cart product List
  cartProductList: any[] = [];
  countriesList = [];
  clearData: any;
  appCode:any;
  quantityData= {quantity: 1};
  getRowDataqQuantity: any;
  userAppCode:any;
  myQty:any;
  QRJSON: any;
  payOutModal: NzModalRef;
  qrCodeModal:NzModalRef;
  cartRemarkForm: UntypedFormGroup;
  addressForm:UntypedFormGroup;
  paymentDetails:any;
  addressDetails:any;
  clearCartList:any;
  appCodes =  appCodes;

   paymentValue = [
    { label: 'QR Code', value: 'qRCode' },
    { label: 'Card', value: 'card' },
    { label: 'Cash', value: 'cash' }
  ];
  formArray:UntypedFormArray;
  addrArray:UntypedFormArray;
  constructor(
    public ordersService: OrdersService,
    public drawerService: NzDrawerService,
    public commonService: CommonService,
    public modal: NzModalService,
    public notification: NzNotificationService,
    public authService: AuthService,
    public modalService: NzModalService,
    public fb: UntypedFormBuilder,
    public dashboardService: DashboardService,
  ) {
    this.addressForm = this.fb.group({
      deliveryMethod:[null,[Validators.required]],
      displayName:[''],
      mobileNo:[''],
      countryCode:[''],
      country: ['',[Validators.required]],
      state: ['',[Validators.required]],
      city: ['',[Validators.required]],
      street:['',[Validators.required]]
    });
   }

  ngOnInit() {
    this.merchantId =+ encryptStorage.getItem('merchantId');
    this.currencySymbol = encryptStorage.getItem('currencySymbol');
    this.tableData.search.isAvailable=true;
    this.loginUserType = this.authService.getRole();
    this.getLocations();
    this.refresh();
    this.userAppCode = this.authService.getAppCode();
    if(this.userAppCode === this.appCodes.adbUATNew){
      this.getCountries();
    }
   
    let cartId = encryptStorage.getItem('cartId');
    if(cartId){
      this.selectCartList();
    }
    this.selectCartList();
   this.onChangeQuantityData();
   this.intializeCheckout();
   this.clearCartList = this.ordersService.clearCartList.subscribe((val) => {
    this.clearCartItemOnList(this.clearData,val);
  });
   }
   intializeCheckout(){ 
    this.paymentDetails = {
      orderId: 6,
      paymentMode: [
      {
        enable: false,
        paymentType: "qrcord",
        amount:0,
        remarks: ""
      },
      {
      enable: false,
      paymentType: "card",
      amount:0,
      remarks: ""
      },
      { 
        enable: false,
        paymentType: "cash",
        amount:0,
        remarks: ""
      },
      {
      enable: false,
      paymentType: "adjustment",
      amount:0,
      remarks: ""
      }
      ],
      totalAmount:0
      }
      this.formArray = this.fb.array([]);
      this.cartRemarkForm = this.fb.group({
           paymentMode: this.formArray,
         });
    this.patch();
   }
  patch() {
    const control = <UntypedFormArray>this.cartRemarkForm.get('paymentMode');
     this.paymentDetails.paymentMode.forEach(x => {
      control.push(this.patchValues(x.enable, x.paymentType,x.amount,x.remarks))
    })
  }
  patchValues(enable,paymentType,amount,remarks) {
    return this.fb.group({
      enable: [enable],
      paymentType: [paymentType],
      amount:[amount],
      remarks:[remarks]
    })
  }
  onChangeQuantityData(){
    this.getRowDataqQuantity = this.quantityData.quantity;
   }
   amountChange(event){
    let sum=0;
    this.cartRemarkForm.value.paymentMode.forEach(element => {
      sum += +element.amount;
    });
    this.remainingAmount = this.totalFinalAmount - sum;
   }
  //  amountCalculationForAdjustment(event){
  //   let sum=0;
  //   this.cartRemarkForm.value.paymentMode.forEach(element => {
  //    
  //     if(element.paymentType !== 'adjustment')
  //      sum += +element.amount;
  //   });
  //   this.remainingAmount = sum === 0 ? this.totalFinalAmount :(this.totalFinalAmount - sum);
  //  }
  // For List
  refresh(startFromPageOne: boolean = true): void {
    this.loadingforProductList = true;
    //this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.pageSize = 10;
    this.tableData.search.merchantId = this.merchantId;
    this.tableData.search.appCode = this.authService.getAppCode();
     this.ordersService.getAllProductlist(this.tableData).subscribe((response: any) => {
       this.loadingforProductList = false;
      this.tableData.total = response.data.total;
      this.productList = response.data.merchantLocationProducts;
        if(this.cartProductList && this.productList){
         this.setDefaultProductQuantities();
       }
      this.allProductIsEdit = true;
      //this.selectCartList();
 //     this.getPendingCartItems();
    }, err => {
      this.loadingforProductList = false;
      //this.loading=false;
      this.productList = [];
    });
  }
  // For Page Index change
  onIndexChangeForAllProduct(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }
  paymentModeForChck(name,i){
    if(this.formArray.value[i].enable === false){
      this.formArray.at(i).get('amount').patchValue(0);
      this.formArray.at(i).get('remarks').patchValue('');
      this.amountChange(i);
      }
  if(name === 'Adjustment' && this.remainingAmount > 0 && !(this.formArray.value[i].enable === false)){
       this.amountChange(i);
       this.formArray.at(i).get('amount').patchValue(this.remainingAmount);
      this.remainingAmount=0;
   }
//   else if(name !== 'Adjustment' && this.remainingAmount > 0 && this.formArray.value[i].enable === false){
//     this.amountCalculationForAdjustment(i);
//     this.formArray.at(3).get('amount').patchValue(this.remainingAmount);
//    this.remainingAmount=0;
// }
  }
  // List for Selected Product 
  selectCartList(startFromPageOne: boolean = true): void {
    this.cartProductList = [];
    this.selectTableData.data = [];
    if (startFromPageOne) {
      this.selectTableData.pageIndex = 1;
    }
    this.selectTableData.search.locationId = this.tableData.search.locationId;
    this.selectTableData.search.status = this.status.Active;
    if(this.isHoldData){this.selectTableData.search.status=this.status.Hold;}
     this.selectTableData.search.userCartId=+ localStorage.getItem('cartId');
    this.selectTableData.search.appCode = this.authService.getAppCode();
    this.ordersService.getSelectProductListWithLimit(this.selectTableData).subscribe((response: any) => {
       this.loading = false;
      this.selectTableData.total = response.data.total;
      this.cartProductList = response.data.userCartItems;
      this.clearData =+ localStorage.getItem('cartId');//this.cartProductList[0].userCartId;
      this.appCode = this.cartProductList[0].appCode;
      console.log('cartProductList test', this.cartProductList);
      this.setButtonVisibility(this.cartProductList);
       this.getTotalAmount();
    }, () => {
       this.loading = false;
       this.totalAmount=0;
      this.totalSavings=0;
      this.totalProducts=0;
      this.totalFinalAmount=0;
    });
  }
  setButtonVisibility(cartList){
    for(let item of cartList){
     item.isEdit=false;
   }
  }
  //Get the current Offer price
  getOfferPrice(items){
    for(let item of items){
      let today =new Date().toISOString();
      if(item.startTime < today && item.endTime > today){
        return item.offerPrice;
      }
    }
    }
  // For Page Index change
  onIndexChangeForSelectCartList(event) {
    this.selectTableData.pageIndex = event;
    this.selectCartList(false);
  }
  // For Page Index Change
  onIndexChangeForPendingCartList(event){
    this.pendingTableData.pageIndex=event;
    this.getPendingCartItems(false);
  }
  // For Available Tag color
  getAvailableColor(value) {
    return this.commonService.getAvailableColor(value);
  }
  getAvailableStatus(value) {
    return this.commonService.getAvailableStatus(value);
  }
  getColorForAvailableStatus(value) {
    return this.commonService.getColorForAvailableStatus(value);
  }

  // Edit Cart confirmation popup
  editCartItem(item) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to update User Cart Item?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.saveEdit(item),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
     this.tableData.search.locationId = this.locationsList[0].id;
  }
  //Get the HashId based on the selection
  getHashId(id){
    for(let item of this.locationsList){
      if(item.id === id){
        this.hashId = item.hashId;
      }
    }
  }
  // Add Cart confirmation popup
  addCart(item) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to add this product (' + item.productName + ') on Cart list ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.selectedProductItemAddedOnList(item),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Add Cart Item Selected Product on List API
  selectedProductItemAddedOnList(data) {
    console.log('check data', data);
    this.getRowData = data;
    const args = {
      merchantLocationId: this.tableData.search.locationId,
      appCode: this.getRowData.appCode
    }
    if (this.loginUserType !== this.userType.merchantUser) {
      let locationDetails = this.authService.getLocationDetails()
      args.merchantLocationId = locationDetails.hashId;
    }
    this.ordersService.selectProductCreateCart(args).subscribe(
      (res: any) => {
         this.notification.success(Messages.saved, '', {
          nzKey: 'key',
        });
      },
      (error) => {
      });
  }
  // Create Cart Item On List 
  cartItemCreateOnList(item) {
    this.loading=true;
    this.isHoldData=false;
    this.getHashId(item.locationId);
    const args = {
      merchantLocationId: this.hashId,//this.tableData.search.locationId,
      appCode: item.appCode,
      merchantProductId: item.productId,
      quantity:item.quantity
    }
     this.ordersService.selectProductCreateCartItem(args).subscribe(
      (res:any) => {
        localStorage.setItem('cartId',res.data.cartId)
        //this.refresh();
        this.selectCartList();
         this.notification.success(Messages.saved, '', {
          nzKey: 'key',
        });
        this.setDefaultProductQuantities();
      },
      (error) => {
        this.loading=false;
      });
  }
  valuechange(newValue) {
    this.defaultQtyValue = newValue;
  }
  saveEdit(item): void {
    this.loading=true;
      const value = {
      merchantLocationId: item.merchantLocationId,
      appCode:item.appCode,
      merchantProductId: item.merchantProductId,
      quantity: item.quantity,
      productPrice: item.productPrice
    }
     this.ordersService.editUserCartItem(value, item.id).subscribe(
      (res) => {
        this.selectCartList();
         this.notification.success(Messages.saved, '', {
          nzKey: 'key',
        });
      },
      (error) => {
        this.loading=false;
       });
  }
 setDefaultProductQuantities(){ 
   for(const item of this.productList)
  {
   item.quantity = 1;
  }
 }

  // Delete Cart Item confirmation
  showDeleteConfirm(data) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to delete this Cart Item?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteCartItem(data),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Delete API request
  deleteCartItem(data) {
    this.loading=true;
    this.ordersService.deleteCartItem(data.id).subscribe((res) => {
      this.selectCartList();
      this.notification.success(Messages.deleted, "", {
        nzKey: "key",
      });
    },err=>{
      this.loading=false;
    });
  }
  // Add Clear Cart confirmation popup
  clearCart(item,isHoldData) {
     this.modal.confirm({
      nzTitle: 'Are you sure you want to Clear The Cart products ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.clearCartItemOnList(item,isHoldData),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Clear Cart Item On List 
  clearCartItemOnList(item,isHoldData) {
    this.loading=true;
    this.ordersService.clearCartItem(item).subscribe((res) => {
      this.removeLocalStorageItem();
      //this.refresh();
      this.orderNumber='';
       //this.selectCartList();
      this.cartProductList = [];
      if(isHoldData){
        this.getPendingCartItems();
      }
      this.notification.success(Messages.deleted, "", {
        nzKey: "key",
      });
      this.loading=false;
      this.totalProducts=0;
    },err=>{
      this.loading=false;
    });
  }

  // Plus Minus toggle button
  quantityPlus(item) { 
    let plus=1;
    if(item.quantity != 10){
      item.quantity = item.quantity + plus;
     }
  }
  quantityMinus(item) {
    let plus=1;
    if(item.quantity != 1){
      item.quantity = item.quantity - plus;
    }
  }
  cartQuantityPlus(item) {
      let plus=1;
     if(item.quantity != 10){
      item.isEdit=true;
      item.quantity = item.quantity + plus;
      }
  }
  cartQuantityMinus(item) {
    let plus=1;
    if(item.quantity != 1){
      item.isEdit=true;
      item.quantity = item.quantity - plus;
      }
  }
  payOut(
    merchantPayOutModal: TemplateRef<{}>,
    merchantPayOutFooter: TemplateRef<{}>
  ){
     this.payOutModal = this.modal.create({
      nzContent: merchantPayOutModal,
      nzFooter: merchantPayOutFooter,
      nzClosable: false,
      nzMaskClosable: false,
      nzOkText: 'Yes',
      //nzOnOk: () => this.createOrder(),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
   loadPendingMethods()
  {
    this.getPendingCartItems();
  }
  loadProductList(){
     if(!this.isActiveCart){
      this.removeLocalStorageItem();
    }
   this.selectCartList();
  }
  payOutClicked() {
    //  const args = {
    //   merchantId: this.merchantId,
    //   productId: data.productId,
    //    locationId: this.tableData.search.locationId,
    // }
    // this.ordersService.payOut(data.id, args).subscribe(
    //   (res) => {
    //     this.refresh();
    //     this.notification.success(Messages.updated, '', {
    //       nzKey: 'key'
    //     });
    //   },
    //   (error) => {
    //   });
  }
  viewDetails(id){
    localStorage.setItem('cartId',id);
    this.isHoldData=true;
    this.loading=true;
    this.selectCartList();
  }
   // Edit Cart confirmation popup
   updateCartItems(id,type) {
    this.modal.confirm({
      nzTitle: type == 'hold'? 'Are you sure you want to Hold User Cart Items?' : 'Are you sure you want to Move Items to Cart?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.holdCart(id,type),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  holdCart(id,type){
    this.loading=true;
    this.getHashId(this.tableData.search.locationId);
     const value={
      appCode:this.appCode,
      merchantLocationId:this.hashId,
       cartId: id,
       status: this.status.Hold
    }
    this.loading=true;
    if(type === 'active'){
    this.isActiveCart=true;
     value.status = this.status.Active;
     this.selectedIndex=0;
     this.isHoldData=false;
    }
    localStorage.setItem('cartId',id);
     this.ordersService.holdCartItems(value).subscribe(
      (res) => {
        if(type === 'hold'){
          this.isActiveCart=false;
          this.removeLocalStorageItem();
        }
        this.getPendingCartItems();        
        this.selectCartList();
        this.notification.success(Messages.updated, '', {
          nzKey: 'key',
        });
      },
      (error) => {
        this.loading=false;
      });
  }
  getPendingCartItems(startFromPageOne: boolean = true){
    this.pendingCartList = [];
    this.pendingTableData.data = [];
    this.pendingCartLoading=true;
    if (startFromPageOne) {
      this.pendingTableData.pageIndex = 1;
    }
    this.pendingTableData.search.locationId = this.tableData.search.locationId;
    this.pendingTableData.search.status=this.status.Hold;
    this.pendingTableData.search.appCode = this.authService.getAppCode();
    this.ordersService.pendingCartItems(this.pendingTableData).subscribe((response: any) => {
      this.pendingCartLoading = false;
      this.appCode = response.data.userCarts[0].appCode;
      this.pendingTableData.total = response.data.total;
      this.pendingTableData.data = response.data.userCarts;
      }, (err) => {
      this.pendingCartLoading = false;
    });
  }
  destroyModal() {
    this.cartRemarkForm.reset();
    this.payOutModal.destroy();
    this.intializeCheckout();
    this.remainingAmount = this.totalFinalAmount;
  }
  destroyQRCodeModal(){
    this.qrCodeModal.destroy();
  }
  getTotalAmount(){
    let userCartId =+ localStorage.getItem('cartId');
    this.ordersService.getTotalAmount(userCartId).subscribe((response: any) => {
      this.totalAmount = response.data.totalProductPrice;
      this.totalProducts = response.data.totalProducts;
      this.totalFinalAmount = response.data.totalFinalAmount;
      this.totalSavings = response.data.totalSavings;
      this.remainingAmount=this.totalFinalAmount;
    }, (err) => {
    });
  }
  totalEnteredAmount(){
    let sum=0;
    this.cartRemarkForm.value.paymentMode.forEach(element => {
      sum += +element.amount;
    });
   return sum;
  }
  pay(){
    let amount=this.totalEnteredAmount();
     if(this.remainingAmount < 0){
      this.notification.error('Remaining Amount should not be lesser than 0', '', {
        nzKey: 'key'
      });
     }
     else if(this.remainingAmount > 0){
      this.notification.error('Payment not fully collected from the Total Amount', '', {
        nzKey: 'key'
      });
     }
     else if(this.totalFinalAmount !== amount){
      this.notification.error('Please check the amount you entered.', '', {
        nzKey: 'key'
      });
     }
     else if(!(this.addressForm.value.deliveryMethod ===this.deliMethods.walkin) && !this.addressForm.valid){
       for (const i in this.addressForm.controls) {
        this.addressForm.controls[i].markAsDirty();
        this.addressForm.controls[i].updateValueAndValidity();
        this.notification.error(Messages.error, '', {
          nzKey: 'key'
        });
      }
     }
      else{
       this.loadingforPay=true;
      this.getHashId(this.tableData.search.locationId);
      const copyForm=Object.assign({}, this.addressForm.value);
      delete copyForm.deliveryMethod;
        const value ={
        cartId:+ localStorage.getItem('cartId'),
        orderCreatedFrom: "counter",
        merchantLocationId:this.hashId,
        appCode:this.appCode,
        mobileNo:this.addressForm.value.mobileNo,
        displayName:this.addressForm.value.displayName,
        countryCode:(this.userAppCode === this.appCodes.adbUATNew) ? this.addressForm.value.countryCode : this.appCodes.otherappCode,
        deliveryMethod:this.addressForm.value.deliveryMethod,
        deliveryAddress:this.addressForm.value.deliveryMethod !== this.deliMethods.walkin? JSON.stringify(copyForm):''
      }
      this.ordersService.createOrder(value).subscribe((response: any) => {
       this.orderId = response.data.id;
      this.orderNumber = response.data.orderNumber;
      this.removeUnUsedPayments();
      this.paymentDetails ={
       orderId:this.orderId,
       totalAmount:this.totalAmount,
       paymentMode:this.formArray.value
     }
    this.ordersService.createReceipt(this.paymentDetails).subscribe((response: any) => {
      this.notification.success(Messages.success, '', {
        nzKey: 'key'
      });
      this.payOutModal.destroy();
      this.cartRemarkForm.reset();
      this.addressForm.reset();
      this.selectCartList();
      this.orderNumber='';
      localStorage.removeItem('cartId');
      this.intializeCheckout();
     this.loadingforPay = false;
     }, (err) => {
       this.cartRemarkForm.reset();
      this.loadingforPay = false;
   })
      // this.loadingforPay=false;
       this.removeLocalStorageItem();
      }, (err) => {
      this.loadingforPay=false;
       });
     }
  }
  removeUnUsedPayments(){
    for(let i=3;i>=0;i--){
     if(!this.formArray.value[i].enable){
     this.formArray.removeAt(i);
     }
    }
   }
  getStatusColor(status) {
    return this.commonService.getStatusColor(status);
  }
  getStatusText(status) {
    return this.commonService.getStatusText(status);
  }
  removeLocalStorageItem(){
    localStorage.removeItem('cartId');
  }
  checkOut( 
    merchantPayOutModal: TemplateRef<{}>,
    merchantPayOutFooter: TemplateRef<{}>)
    {
      this.payOut(merchantPayOutModal,merchantPayOutFooter)
    }
  // createOrder(){
  //      this.loadingforCheckOut=true;
  //     this.getHashId(this.tableData.search.locationId);
  //     const value ={
  //       cartId:+ localStorage.getItem('cartId'),
  //       orderCreatedFrom: "counter",
  //       merchantLocationId:this.hashId,
  //       appCode:this.appCode
  //     }
  //     this.ordersService.createOrder(value).subscribe((response: any) => {
  //      this.orderId = response.data.id;
  //     this.orderNumber = response.data.orderNumber;
  //     this.loadingforCheckOut=false;
  //     this.removeLocalStorageItem();
  //     }, (err) => {
  //     this.loadingforCheckOut=false;
  //      });
  // }
  getOffersList(selectedRow): void {
    let data = selectedRow;
    const drawerRefCreate = this.drawerService.create<ProductOffersComponent, { selectedRow: string,isNewOrder:boolean }, string>({
      nzContent: ProductOffersComponent,
      nzTitle: 'Offers',
      nzWidth: '860px',
      nzClosable: true,
      nzContentParams: {
        selectedRow: data,
        isNewOrder:true
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    // For drawer close after save and to load the page
    drawerRefCreate.afterClose.subscribe(res => {
      if (res && typeof res !== null) {
        this.refresh();
      }
    });
  }
  getActiveOffersCount(data){
    if(data.length>0){
     return  data.filter(x=>x.status ===1).length
    }
  }
  clearSearch(value) {
    return this.ordersService.clearSearchFields(this.tableData, value);
  }
  showQRCode(
    qrCodeModal: TemplateRef<{}>,
    qrCodeFooter: TemplateRef<{}>
  ){
    this.qrCodeModal = this.modal.create({
      nzContent: qrCodeModal,
      nzFooter: qrCodeFooter,
      nzTitle:'QR Code',
      nzClosable: false,
      nzMaskClosable: false,
      nzOkText: 'Yes',
      //nzOnOk: () => this.createOrder(),
      nzCancelText: 'No',
     });
      this.selectedLocation = this.locationsList.filter(x=>x.id===this.tableData.search.locationId)[0];
     this.setQRJsonData();
  }
  setQRJsonData(){
    this.QRJSON = {
      type: 'MERCHANT',
      locationId:this.locationId,
      currency: this.currencySymbol,
      merchantId: this.merchantId,

      // For Mobile Side fix
      location_id: this.locationId,
      merchant_id: this.merchantId,
};
this.QRJSON = JSON.stringify(this.QRJSON);
  }
// For Country Field
getCountries() {
  this.ordersService.getAllCountries().subscribe((response: any) => {
    this.countriesList = response.data.countries;
  });
}
}
